module.exports = __webpack_public_path__ + "img/ZeldaGameplay.e4034030.png";